module.exports = __webpack_public_path__ + "static/media/buses-icon.779c6056.PNG";